import { render } from "./WordChallenge.vue?vue&type=template&id=98cc3034&scoped=true"
import script from "./WordChallenge.vue?vue&type=script&lang=js"
export * from "./WordChallenge.vue?vue&type=script&lang=js"

import "./WordChallenge.vue?vue&type=style&index=0&id=98cc3034&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-98cc3034"

export default script